export default "__VITE_ASSET__CZOeUBWy__"